import { View } from "@react-pdf/renderer";
import { ResumePDFDescription } from "components/Resume/ResumePDF/common";
import { styles } from "components/Resume/ResumePDF/styles";
import type { ResumeCustom } from "lib/redux/types";
import { TemplateSixPDFSectionWithSubsections as TemplateSixPDFSection } from "./common";

export const Custom = ({
  heading,
  custom,
  themeColor,
}: {
  heading: string;
  custom: ResumeCustom;
  themeColor: string;
}) => {
  const { descriptions } = custom;

  return (
    <TemplateSixPDFSection themeColor={themeColor} heading={heading}>
      <View style={{ ...styles.flexCol }} wrap={false}>
        <ResumePDFDescription items={descriptions} />
      </View>
    </TemplateSixPDFSection>
  );
};
